import { Theme } from '../models/theme';

export const LVTheme: Theme = {
  id: 1,
  name: 'LearnerVerified',
  description: 'Default LearnerVerified Theme',
  swatches: ['#1d428A', '#26d07c', '#0f0f0f', '#ededed'],
  properties: {
    'color-primary': '#1d428A',
    'color-accent': '#26d07c',
    'color-text': '#0f0f0f',
    'color-surface': '#ffffff',
    'color-background': '#f2f2f2'
  }
};
